import { render, staticRenderFns } from "./board-header.vue?vue&type=template&id=5d3985ea&"
import script from "./board-header.vue?vue&type=script&lang=ts&"
export * from "./board-header.vue?vue&type=script&lang=ts&"
import style0 from "./board-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports